import { Link } from "react-router";
import { ROUTES } from "../../lib/constants";

export function DataCoverageNotice({ showPricing = true }: { showPricing?: boolean }) {
  return (
    <aside aria-label="Public beta and data coverage" className="rounded-md border border-barrel/40 bg-white p-4 text-left text-sm text-terroir mb-6">
      <p className="font-medium text-garnet mb-1">Public beta</p>
      <p>
        We continue to build, index, and enrich the dataset. Coverage and detail vary by wine;
        finding a wine does not mean every field, price, or historical record is available.
      </p>
      {showPricing && (
        <p className="mt-2">
          Pricing coverage is limited. Many wines may return no price records. Available records
          are not guaranteed to reflect a current retail offer. History is still accumulating
          and may be empty or too sparse to show a meaningful trend. Upgrading provides feature
          access, not guaranteed data for particular wines.
        </p>
      )}
      <Link to={ROUTES.DATA_COVERAGE} className="inline-flex min-h-11 items-center text-barrel underline underline-offset-2">
        Data Coverage &amp; FAQ
      </Link>
    </aside>
  );
}
